import { useState } from "react";
import { Trash2 } from "lucide-react";

/**
 * SwipeableRow — wraps content in a touch-swipeable container with a red
 * "delete" reveal beneath. Sveip > 100px venstre + slipp = trigger onDelete.
 * Desktop er uendret (vi bruker pointer-touch detection så mus ikke trigger).
 */
export default function SwipeableRow({ children, onDelete, testid }) {
  const [offset, setOffset] = useState(0);
  const [start, setStart] = useState(null);
  const [active, setActive] = useState(false);

  const handleStart = (e) => {
    // Only react to touch events (skip mouse for desktop UX)
    if (e.type === "touchstart") {
      setStart(e.touches[0].clientX);
      setActive(true);
    }
  };
  const handleMove = (e) => {
    if (!active || start === null) return;
    const dx = e.touches[0].clientX - start;
    // Only allow leftward drag, cap at -160
    setOffset(Math.max(-160, Math.min(0, dx)));
  };
  const handleEnd = () => {
    if (!active) return;
    if (offset < -100) {
      // Animate fully out then trigger delete
      setOffset(-400);
      setTimeout(() => onDelete?.(), 180);
    } else {
      setOffset(0);
    }
    setStart(null);
    setActive(false);
  };

  return (
    <div className="relative overflow-hidden" data-testid={testid}>
      {/* Red delete reveal */}
      <div
        className="absolute inset-y-0 right-0 flex items-center justify-end pr-5 bg-red-500 pointer-events-none"
        style={{ width: Math.max(0, -offset) }}
        aria-hidden
      >
        {offset < -40 && <Trash2 className="h-5 w-5 text-white" />}
      </div>
      <div
        onTouchStart={handleStart}
        onTouchMove={handleMove}
        onTouchEnd={handleEnd}
        onTouchCancel={handleEnd}
        className="bg-white relative"
        style={{
          transform: `translateX(${offset}px)`,
          transition: active ? "none" : "transform 180ms ease-out",
        }}
      >
        {children}
      </div>
    </div>
  );
}
